import React from 'react';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ filters, onFilterChange }) => {
  const priorityOptions = [
    { value: 'all', label: 'Toutes les Priorités' },
    { value: 'high', label: 'Haute Priorité' },
    { value: 'medium', label: 'Priorité Moyenne' },
    { value: 'low', label: 'Basse Priorité' }
  ];

  const performanceOptions = [
    { value: 'all', label: 'Toutes Performances' },
    { value: '0-50', label: '0-50% (Faible)' },
    { value: '50-70', label: '50-70% (Moyen)' },
    { value: '70-85', label: '70-85% (Bien)' },
    { value: '85-100', label: '85-100% (Excellent)' }
  ];

  const engagementOptions = [
    { value: 'all', label: 'Tous Niveaux' },
    { value: 'high', label: 'Engagement Élevé' },
    { value: 'medium', label: 'Engagement Moyen' },
    { value: 'low', label: 'Engagement Faible' }
  ];

  return (
    <div className="bg-white rounded-lg p-5 shadow-sm border border-gray-200 sticky top-24">
      <div className="flex items-center gap-2 mb-5">
        <Icon name="Filter" size={20} color="#3b82f6" />
        <h3 className="text-lg font-semibold text-gray-900">Filtres</h3>
      </div>

      <div className="space-y-5">
        <Select
          label="Niveau de Priorité"
          options={priorityOptions}
          value={filters?.priorityLevel}
          onChange={(value) => onFilterChange('priorityLevel', value)}
        />

        <Select
          label="Performance Académique"
          options={performanceOptions}
          value={filters?.performanceRange}
          onChange={(value) => onFilterChange('performanceRange', value)}
        />

        <Select
          label="Niveau d'Engagement"
          options={engagementOptions}
          value={filters?.engagementLevel}
          onChange={(value) => onFilterChange('engagementLevel', value)}
        />

        <div className="pt-4 border-t border-gray-200">
          <Checkbox
            label="Intervention Requise Uniquement"
            checked={filters?.interventionRequired}
            onChange={(e) => onFilterChange('interventionRequired', e?.target?.checked)}
          />
        </div>

        <button
          onClick={() => onFilterChange('reset', null)}
          className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
        >
          Réinitialiser les Filtres
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;